import React, { useState } from "react";
import "./Ticketrise.css";
import { FaPaperPlane } from "react-icons/fa";
import { FaTicketAlt } from "react-icons/fa";
import { title } from "framer-motion/client";
import { m } from "framer-motion";

function Ticketrise() {
  //   const [category, setCategory] = useState("");
  const [ticketform, setTicketform] = useState(true);
  const [ticketsumbitted, setTicketsumbitted] = useState(false);
  const [issumbit, setIssumbit] = useState(false);
  const [ticketforminput, setticketforminput] = useState({
    name: "",
    empId: "",
    phone: "",
    email: "",
    title: "",
    message: "",
    files: null,
  });

  //   const handleChange = (e) => {
  //     setFormData((prev) => ({
  //       ...prev,
  //       [e.target.name]: e.target.value,
  //     }));
  //   };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIssumbit(true);

    const apiUrl = `${process.env.REACT_APP_BASEURL}/apis/googleform.php`;
    const formData = new FormData();
    formData.append("name", ticketforminput.name);
    formData.append("emp_id", ticketforminput.empId);
    formData.append("contact_number", ticketforminput.phone);
    formData.append("email", ticketforminput.email);
    formData.append("e_title", ticketforminput.title);
    formData.append("e_des", ticketforminput.message);
    formData.append("files", ticketforminput.files);

    try {
      const response = await fetch(apiUrl, {
        method: "POST",
        body: formData,
      });
      const data = await response.json();
      if (response.ok && data.message === "Ticket created successfully. An email has been sent with the ticket details.") {
        setticketforminput({
          name: "",
          empId: "",
          phone: "",
          email: "",
          title: "",
          message: "",
        });
        setTicketsumbitted(true);
        setTicketform(false);
      } else {
        alert(data.message);
      }
    } catch (error) {
      console.log("Error with POST request:", error);
    } finally {
      setIssumbit(false);
    }
  };

  return (
    <div>
      {ticketform && (
        <>
          <div className="ticket-form-container">
            <h2>Raise a Ticket</h2>
            <form
              onSubmit={handleSubmit}
              className={`ticket-form ${issumbit ? "blurred" : ""}`}
            >
              <input
                type="text"
                placeholder="Name"
                value={ticketforminput.name}
                onChange={(e) =>
                  setticketforminput((pv) => ({ ...pv, name: e.target.value }))
                }
                required
              />
              <input
                type="text"
                placeholder="Employee ID"
                value={ticketforminput.empId}
                onChange={(e) =>
                  setticketforminput((pv) => ({ ...pv, empId: e.target.value }))
                }
                required
              />
              <input
                type="tel"
                pattern="[0-9]{10}"
                title="Please enter a valid 10-digit phone number"
                placeholder="Phone Number"
                value={ticketforminput.phone}
                onChange={(e) =>
                  setticketforminput((pv) => ({ ...pv, phone: e.target.value }))
                }
                required
              />
              <input
                type="email"
                placeholder="Email"
                value={ticketforminput.email}
                onChange={(e) =>
                  setticketforminput((pv) => ({ ...pv, email: e.target.value }))
                }
                required
              />

              <select
                value={ticketforminput.title}
                onChange={(e) =>
                  setticketforminput((pv) => ({ ...pv, title: e.target.value }))
                }
                required
              >
                <option value="" disabled selected>
                  Select Category
                </option>
                <option value="Salary">Salary</option>
                <option value="PF">PF</option>
                <option value="Insurance">Insurance</option>
                <option value="OT">OT</option>
                <option value="Offer Letter">Offer Letter</option>
                <option value="Releaving">Releaving</option>
                <option value="KYC">KYC</option>
                <option value="Others">Others</option>
              </select>

              <textarea
                placeholder="Please specify your issue"
                value={ticketforminput.message}
                onChange={(e) =>
                  setticketforminput((pv) => ({
                    ...pv,
                    message: e.target.value,
                  }))
                }
                required
              />

              <input
                type="file"
                onChange={(e) =>
                  setticketforminput((pv) => ({
                    ...pv,
                    files: e.target.files[0],
                  }))
                }
              />

              <button type="submit">
                Submit Ticket <FaPaperPlane style={{ marginLeft: "8px" }} />
              </button>
            </form>
          </div>
        </>
      )}

      {ticketsumbitted && (
        <div className="ticket-success">
          <FaTicketAlt className="ticket-icon" />
          <h3>
            Thanks! Your ticket has been submitted successfully.
            <br />
            We'll follow up with you soon through email or phone.
          </h3>
        </div>
      )}
    </div>
  );
}

export default Ticketrise;
